import { colorPalette } from "../components/util";
import { initialView } from "./initialView";
import { missouri } from "./layers";
import { GlobalState } from "../App";
import React from "react";

export const initialState: GlobalState = {
  layers: [missouri],
  metaLookup: {
    [missouri._id]: { lineColor: colorPalette(Math.random()), hidden: false }
  },
  view: initialView,
  mapTheme: "mapbox://styles/drewweth/ck69pz7hb2h0j1ilqz7ikuw3r",
  description: undefined,
  showLibrary: false,
  showTutorial: true,
  showMobileWarning: true
};
